import { styled } from '@mui/material/styles';
import Badge, { badgeClasses as muiBadgeClasses } from '@mui/material/Badge';
import inRange from 'lodash/inRange';
import { badgeClasses } from './badgeClasses';

const propsForStylingOnly = [
  'negativeRange',
  'positiveRange',
  'incomingBadgeContent',
  'inline'
];

function getTrendColorStyles(props, theme) {
  const {
    incomingBadgeContent: trendValue,
    negativeRange,
    positiveRange
  } = props;

  // default case (0 value)
  let color = theme.palette.grey[700];
  let backgroundColor = theme.palette.grey[50];

  if (Array.isArray(positiveRange)) {
    const [startOfPositiveRange, endOfPositiveRange] = positiveRange;
    if (inRange(trendValue, startOfPositiveRange, endOfPositiveRange)) {
      color = theme.palette.success.dark;
      backgroundColor = theme.palette.success.light;
    }
  }
  if (Array.isArray(negativeRange)) {
    const [startOfNegativeRange, endOfNegativeRange] = negativeRange;
    if (inRange(trendValue, startOfNegativeRange, endOfNegativeRange)) {
      color = theme.palette.error.dark;
      backgroundColor = theme.palette.error.light;
    }
  }

  return { backgroundColor, color };
}

export const BadgeRoot = styled(Badge, {
  shouldForwardProp: prop => !propsForStylingOnly.includes(prop),
  name: 'AFBadge'
})(({ theme, ...props }) => ({
  ...(props.variant === 'custom' && {
    display: 'flex',
    alignItems: 'center'
  }),
  '&:focus, &:focus-visible': {
    outline: 'none',
    [`& .${muiBadgeClasses.badge}`]: {
      outline: `1px solid ${theme.palette.primary.main}`
    }
  },
  [`& .${badgeClasses.trend}`]: {
    color: getTrendColorStyles(props, theme).color,
    backgroundColor: getTrendColorStyles(props, theme).backgroundColor
  },
  [`& .${badgeClasses.counter}`]: {
    minWidth: 20,
    backgroundColor: theme.palette.grey[100],
    color:
      props.color === 'secondary'
        ? theme.palette.grey[700]
        : theme.palette.primary.main
  },
  [`& .${badgeClasses.notification}`]: {
    backgroundColor: theme.palette.error.main
  },
  [`& .${badgeClasses.premium}`]: {
    borderRadius: 4,
    fontWeight: 400,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.premium.main
  },
  [`& .${badgeClasses.new}`]: {
    borderRadius: 4,
    fontWeight: 400,
    backgroundColor: theme.palette.new.main
  },
  [`& .${badgeClasses.beta}`]: {
    borderRadius: 4,
    fontWeight: 400,
    color: '#0B7285',
    backgroundColor: '#E3FAFC'
  },
  [`& .${badgeClasses['coming-soon']}`]: {
    borderRadius: 4,
    fontWeight: 400,
    color: '#6D2FF0',
    background: '#F3F0FF',
    [`&.${muiBadgeClasses.badge}`]: {
      width: 'max-content'
    }
  },
  [`& .${badgeClasses.custom}`]: {
    position: 'relative',
    transform: 'none',
    transformOrigin: 0,
    borderRadius: 4
  },
  [`& .${badgeClasses.recommended}`]: {
    borderRadius: 4,
    fontWeight: 400,
    color: theme.palette.teal[900],
    backgroundColor: theme.palette.teal[50]
  },
  [`& .${badgeClasses.inline}`]: {
    position: 'relative',
    transform: 'none',
    height: 'auto'
  }
}));
